import {
  configureStore,
  applyMiddleware,
  combineReducers
} from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import answersSlice from 'slices/answersSlice';
import formStateSlice from 'slices/formStateSlice';
import reporterSlice from 'slices/reporterSlice';

const reducers = {
  answers: answersSlice,
  formstate: formStateSlice,
  reporter: reporterSlice
};

const rootReducer = combineReducers(reducers);

const initialState = {
  answers: {},
  formState: {
    identifyMyself: [],
    victim: [],
    anotherVictim: [],
    subject: [],
    subject2: [],
    reportID: '',
    reportingID: '',
    reportStatus: [],
    answers: [],
    selectedOptions: []
  },
  reporter: {
    anonymous: {},
    reporting_party: {}
  }
};

const middleware = [thunk];

const store = configureStore(
  { reducer: rootReducer },
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
